import { Route } from 'types/route.type';
import Growth from './growth';

export const routes: Route[] = [
  {
    path: '/benchmark-analytics/growth',
    component: Growth,
  },
];
